import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Esta leyenda data de 1406, época del emperador de la brillante alegría. Un hombre que adoptará las tierras de
      China como su casa, le pregunta a una mujer por el sonido de una campana y promete contar la historia para la
      gente de su país con todo el respeto por el sentido, al querer expresarlo en las “rudas palabras occidentales para
      revelar el misterio de oriente”. Así que la mujer empieza a contar la historia.
    </p>
    <p className="content justified">
      El emperador Yung-lo deseaba tener una campana de gran tamaño, que repicara por gran parte de su territorio, la
      cual debía ser el resultado de la fundición de varios metales para que cada uno le diera su virtud.
    </p>
    <p className="content justified">
      La campana fue encargada y para su elaboración se utilizaron medidas exactas y las mejores balanzas para pesar los
      metales. Pero, a pesar de esto, los metales continuaban separados. Ante el descontento del emperador, todo debía
      volver a hacerse: encender las hogueras y ensayar la combinación de los metales. El resultado fue peor.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Si el encargado de hacer la campana traicionaba por tercera vez a Yung-lo, su cabeza sería cortada. “Tiembla y
      obedece”, fueron las palabras del emperador, que se sellaron con el símbolo del dragón, lo que significa muerte.
    </p>
    <p className="content justified">
      El fundidor tenía una hermosa hija llamada Adorable, quien estaba muy preocupada por el futuro de su padre, pues
      su vida dependía de la exitosa elaboración de la campana. Así que consultó a un hombre sabio, pero temido, para
      saber qué debía hacer.
    </p>
    <p className="content justified">
      Después de conocer la respuesta, Adorable decidió ofrecerle a su padre la mayor prueba de amor filial y que así
      los metales pudieran mezclarse para formar la gran campana. ¿Qué crees que hizo?
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">Contar los misterios de oriente</h3>
      <p className="content justified">
        En este radioteatro parece que el hombre que habla al comienzo de la narración y que expresa admiración por las
        historias de oriente se trata del mismo Oswaldo Díaz Díaz. En este libreto, Don Os pudo haberse incluido de
        manera indirecta como uno de los personajes del episodio, pues él, al igual que este hombre, tiene un gran
        respeto y cuidado al contar las leyendas de otras partes del mundo para que puedan ser conocidas en otros
        territorios.
      </p>
      <p className="content justified">
        El esmero en el tratamiento de esta leyenda se ve, en primer lugar, en la charla inicial entre el hombre y la
        mujer. En segundo lugar, la narración es pausada, sin que se torne aburrida o lenta. Esta característica está
        dada por el uso del lenguaje delicado y preciso en voz de los personajes. Y la aceleración de los hechos está
        presentada por la narradora de la historia, sin que en ningún momento haya golpes bruscos en el ritmo del
        relato.
      </p>
      <p className="content justified">
        Adicionalmente, Oswaldo Díaz Díaz ofrece un sinnúmero de detalles que evocan la imaginación del oyente como
        cuando se habla de los hermosos “zapatitos bordados de perlas en forma de flores” de Adorable, o cuando se
        mencionan las propiedades que dará cada uno de los metales a la campana.
      </p>
      <p className="content justified">
        Esta historia, lejos de ser aleccionadora, representa de una manera clásica el amor filial.
      </p>
      <p className="content justified">
        La leyenda de la gran campana fue emitida en 1955 en la serie <i>Leyendas</i>, bajo la dirección de Gonzalo Vera
        Quintana, al igual que la leyenda belga “La sopa de piedra”.
      </p>
    </div>
  </div>
);
